import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as R from 'ramda';

const CardoGroupContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const getCardoGroupData = ({ content, data }) => {
  if (typeof data === 'string') {
    // Fetch from the redux store
    return R.pathOr({}, ['cardoGroup', data])(content);
  }

  // Else assume the CardoGroup data is supplied as a prop
  return data;
};

const mapStateToProps = ({ content, breakpoints = {} }, { data }) => ({
  data: getCardoGroupData({ content, data }),
  currentBreakpoint: breakpoints.current,
});

const mapDispatchToProps = undefined;

CardoGroupContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardoGroupContainer);
